export default {
  card: 'Card',
  cash: 'Cash',
  online: 'Online',
}
